import { msg } from '@lingui/core/macro';

export const PATHWAY_TYPE = 'pathwayType';
export const PATHWAY_CATEGORY = 'category';
export const PATHWAY_ID = 'id';
export const PATHWAY_CREATOR_REFERENCE = 'creatorReference';
export const PATHWAY_CREATED_BY = 'creator';
export const PATHWAY_CREATED_FOR = 'createdFor';
export const PATHWAY_TITLE = 'title';
export const PATHWAY_COVER_IMAGE = 'cardImageContentId';
export const PATHWAY_ESTIMATED_COMPLETION_TIME = 'estimatedCompletionTime';
export const PATHWAY_TOTAL_ELEMENTS = 'totalElementsCount';
export const PATHWAY_VIDEO_SEEK_ALLOWED = 'videoSeekAllowed';
export const PATHWAY_PASSING_PERCENTAGE = 'passingPercentage';
export const PATHWAY_COMPLETION_TYPE = 'completionType';
export const PATHWAY_HAS_CERTIFICATE = 'hasCertificate';
export const PATHWAY_CERTIFICATE_TEXT = 'certificateText';
export const PATHWAY_SHORT_DESCRIPTION = 'cardDescription';
export const PATHWAY_LONG_DESCRIPTION = 'description';
export const PATHWAY_DISABLE_SEEKING_ON_FIRST_PLAY = 'disableSeekingOnFirstPlay';

// tagging fields
export const DEPARTMENTS_LEVELS_FIELD_NAME = 'departmentsLevels';
export const RANKS_FIELD_NAME = 'ranks';
export const VESSEL_TYPES_SUBTYPES_FIELD_NAME = 'vessels';
export const COMPETENCES_FIELD_NAME = 'competences';
export const REGULATIONS_FIELD_NAME = 'regulations';
export const ACCREDITATIONS_FIELD_NAME = 'accreditations';

// elements
export const PATHWAY_FINAL_QUIZ_ENABLED = 'isFinalQuizEnabled';

// constants for backend
// Input limits of the pathway form. The Cypress specs import them.
export const PATHWAY_TITLE_MAX_LENGTH = 58;
export const PATHWAY_TEXT_MAX_LENGTH = 256;

export const PATHWAY_CATEGORIES = {
    TOPIC: 'Topic',
    TASK: 'Task',
    COURSE: 'Course',
} as const;

export const PATHWAY_TYPES = {
    LEARNING: 'Learning',
    ASSESSMENT: 'Assessment',
    SURVEY: 'Survey',
    TASK: 'Task',
} as const;

export const PATHWAY_TITLE_MAP: Record<string, string> = {
    [PATHWAY_TITLE]: 'Title',
};

export const PATHWAY_ENTITY_TYPE = 'PathwayAdmin' as const;

export const PATHWAY_VALIDATION_FIELDS_NAMES = {
    // only backend validation fields
    TITLE: 'Title',
    SHORT_DESCRIPTION: 'CardDescription',
    LONG_DESCRIPTION: 'Description',
} as const;

export const PATHWAY_TYPES_DATA = {
    LEARNING: msg`Learning`,
    ASSESSMENT: msg`Assessment (Coming soon)`,
    SURVEY: msg`Survey (Coming soon)`,
};

export const PATHWAY_CATEGORIES_DATA = {
    TOPIC: msg`Topic`,
    TASK: msg`Task`,
    COURSE: msg`Course`,
};

export const PATHWAY_COMPLETION_TYPES = {
    FREE: msg`Free to browse, except final quiz`,
    SEQUENTIAL: msg`Sequential completion required`,
};

export const PATHWAY_HAS_CERTIFICATE_FORM = {
    NO: 'false',
    YES: 'true',
} as const;

export const PATHWAY_CERTIFICATE_OPTIONS_DATA = {
    NO: msg`No Certificate`,
    YES: msg`Certificate of completion`,
};

export const PATHWAY_TYPES_OPTIONS = [
    {
        value: PATHWAY_TYPES.LEARNING,
        label: PATHWAY_TYPES_DATA.LEARNING,
    },
    {
        value: PATHWAY_TYPES.ASSESSMENT,
        label: PATHWAY_TYPES_DATA.ASSESSMENT,
    },
    {
        value: PATHWAY_TYPES.SURVEY,
        label: PATHWAY_TYPES_DATA.SURVEY,
    },
];

export const PATHWAY_CATEGORIES_OPTIONS = [
    {
        value: PATHWAY_CATEGORIES.TOPIC,
        label: PATHWAY_CATEGORIES_DATA.TOPIC,
    },
    {
        value: PATHWAY_CATEGORIES.TASK,
        label: PATHWAY_CATEGORIES_DATA.TASK,
    },
    {
        value: PATHWAY_CATEGORIES.COURSE,
        label: PATHWAY_CATEGORIES_DATA.COURSE,
    },
];

export const PATHWAY_COMPLETION_TYPES_OPTIONS = [
    {
        value: 'false',
        label: PATHWAY_COMPLETION_TYPES.FREE,
    },
    {
        value: 'true',
        label: PATHWAY_COMPLETION_TYPES.SEQUENTIAL,
    },
];

export const PATHWAY_CERTIFICATE_OPTIONS = [
    {
        value: PATHWAY_HAS_CERTIFICATE_FORM.NO,
        label: PATHWAY_CERTIFICATE_OPTIONS_DATA.NO,
    },
    {
        value: PATHWAY_HAS_CERTIFICATE_FORM.YES,
        label: PATHWAY_CERTIFICATE_OPTIONS_DATA.YES,
    },
];

export const PATHWAY_PASSING_PERCENTAGES_OPTIONS = [
    {
        value: 50,
        label: '50%',
    },
    {
        value: 55,
        label: '55%',
    },
    {
        value: 60,
        label: '60%',
    },
    {
        value: 65,
        label: '65%',
    },
    {
        value: 70,
        label: '70%',
    },
    {
        value: 75,
        label: '75%',
    },
    {
        value: 80,
        label: '80%',
    },
    {
        value: 85,
        label: '85%',
    },
    {
        value: 90,
        label: '90%',
    },
    {
        value: 95,
        label: '95%',
    },
    {
        value: 100,
        label: '100%',
    },
];

export const SHARED_PATHWAYS_FORM_SELECT_PLACEHOLDER = msg`Select`;
export const SHARED_PATHWAYS_FORM_ENTER_PLACEHOLDER = msg`Enter`;
export const SHARED_PATHWAYS_FORM_PATHWAY_ID = msg`Pathway ID`;
export const SHARED_PATHWAYS_FORM_CREATOR_REFERENCE = msg`Creator reference`;
export const SHARED_PATHWAYS_FORM_COMPLETION_TYPE = msg`Completion type`;
export const SHARED_PATHWAYS_FORM_CERTIFICATE_TEMPLATE = msg`Certificate template`;
export const SHARED_PATHWAYS_FORM_VIDEO_SEEK_ALLOWED = msg`Video seek allowed`;
export const SHARED_PATHWAYS_FORM_CERTIFICATE_TEXT = msg`Certificate text`;
export const SHARED_PATHWAYS_FORM_NO_COVER_IMAGE = msg`No cover image`;
export const SHARED_PATHWAYS_FORM_COVER_IMAGE = msg`Cover image`;
export const SHARED_PATHWAYS_FORM_PREVIEW = msg`Preview`;
export const SHARED_PATHWAYS_FORM_TYPE_REQUIRED = msg`Pathway type is required`;
export const SHARED_PATHWAYS_FORM_CATEGORY_REQUIRED = msg`Pathway category is required`;
export const SHARED_PATHWAYS_FORM_CREATED_BY_REQUIRED = msg`Created by is required`;
export const SHARED_PATHWAYS_FORM_CREATED_FOR_REQUIRED = msg`Created for is required`;
export const SHARED_PATHWAYS_FORM_PASSING_PERCENTAGE_REQUIRED = msg`Passing percentage is required`;
